import { render, staticRenderFns } from "./DrawerMenuCamadas.vue?vue&type=template&id=9659a506&lang=pug"
import script from "./DrawerMenuCamadas.vue?vue&type=script&lang=js"
export * from "./DrawerMenuCamadas.vue?vue&type=script&lang=js"
import style0 from "./DrawerMenuCamadas.vue?vue&type=style&index=0&id=9659a506&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports